module.exports = __webpack_public_path__ + "static/007279-b103e858a2da021bb0b0213751a974ce.jpg";